import React from 'react'
import { Spin } from 'antd'

import { BrandMark } from '@/Ship/Components/Brand/BrandMark'
import { BrandConfig } from '@/Ship/Configs/BrandConfig'

import styles from './DefaultLoadTemplate.module.css'

/**
 * Екран завантаження застосунку (`loadTemplate`): знак, назва, спінер.
 * Колір і шрифт — з теми (`ThemeProvider`), в обох режимах.
 */
export const DefaultLoadTemplate: React.FC = () => {
    return (
        <div className={styles['loadingContainer']}>
            <div className={styles['backgroundDecoration']}>
                <div className={styles['ellipse']} />
            </div>
            <div className={styles['content']}>
                <BrandMark size={44} />
                <h1 className={styles['logo']}>{BrandConfig.name}</h1>
                <Spin size="large" />
                <p className={styles['loadingText']}>Завантаження додатку...</p>
            </div>
        </div>
    )
}
